import React, { useState, useEffect, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate,updatedata, sendwhatsappmessage, WAITINGGIF} from "../../util/global";

const SettingForm = ({ showmodal, setshowmodal, config, updateconfig, setconfig, title}) => {
    
  useEffect(() => { 

  }, [showmodal]);

  if (showmodal != "showusersettingform" ) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={() => setshowmodal(false)}>&times;</button>
        </div>
        <div className="modal-body">
           <div className="form-group">
            <label>{title} Config</label>
            <textarea 
              type="text" 
              className="form-input" 
              id="config"
              value={config ? config.config : ""} 
              onChange={(e) => {  setconfig({...config, config:e.target.value}) }}
            />              
          </div>
        
          <button className="btn-blue full-width " onClick={() => {updateconfig();}}>
            Save <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px',position:'absolute'}}/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingForm;
